<div class="astrea-home-banner">
    <a [href]="currentBanner.url" [title]="currentBanner.title">
        <img [src]="currentImageSrc" [attr.key]="currentBanner.v" [alt]="currentBanner.title" />
    </a>
    <!-- <img src="/assets/images/banners/vacation-banner.png" alt="Banner Vacaciones 2026" /> -->
</div>
